module.exports = __webpack_public_path__ + "media/images/demo/fixed-menu-c02cb3b3514cd8474966ea1ea63193e0.jpg";